export default {"src":"/_next/static/media/users.795ba82d.svg","height":19,"width":18};